module.exports = __webpack_public_path__ + "img/business_23.f7193e98.jpg";